<template>
    <el-dialog
        v-if="isDialogVisible"
        :visible="true"
        @close="onFormClose"
        title="Quick Group Message"
        :close-on-click-modal="false"
    >
        <loading v-if="isFormBusy"></loading>
        <quick-form
            v-show="!isFormBusy"
            :is-initialized="isInitialized"
            :get-form-url="getFormUrl"
            :excluded-conversation-ids="excludedConversationIds"
            @formInitialized="this.onFormInitialized"
            @formInitializationError="this.onFormInitializationError"
            @created="onCreated"
        ></quick-form>
    </el-dialog>
</template>

<script>
  import eventBus from "../../event-bus";
  import QuickForm from "./quick-form";
  import Loading from "../loading";

  export default {
    components: {
      QuickForm,
      Loading,
    },

    props: {
      excludedConversationIds: Array,
    },

    data() {
      return {
        getFormUrl: null,
        isFormBusy: true,
        isInitialized: false,
      };
    },

    computed: {
      isDialogVisible() {
        return !_.isNull(this.getFormUrl);
      }
    },

    methods: {
      /**
       * @param {*} url
       */
      showForm(url) {
        this.getFormUrl = url;
      },

      /**
       * @return {undefined}
       */
      onFormClose() {
        this.destroyForm();
      },

      /**
       * @return {undefined}
       */
      onFormInitialized() {
        this.isFormBusy = false;
        this.isInitialized = true;
      },

      /**
       * @return {undefined}
       */
      destroyForm() {
        this.isFormBusy = true;
        this.getFormUrl = null;
        this.isInitialized = false;
      },

      /**
       * @param {Object} value
       */
      onFormInitializationError({message}) {
        this.isInitialized = false;
        this.destroyForm();
        message && this.$message.error(message);
      },

      /**
       * @param {Object} value
       */
      onCreated({message}) {
        this.destroyForm();
        message && this.$message.success(message);
        eventBus.$emit('bulk-message-created');
      },
    },

    created() {
      eventBus.$on('show-quick-bulk-message', this.showForm);
    },

    beforeDestroy() {
      eventBus.$off('show-quick-bulk-message', this.showForm);
    },
  }
</script>
